<div class="container-fluid">
    <div class="d-flex justify-content-between align-items-center mb-3 mt-2">
        <h1 class="mb-0">Screen List</h1>
        <div class="header-actions">
            <div class="view-switcher">
                <button type="button" class="view-button" [class.active]="viewMode === 'list'"
                    (click)="setViewMode('list')">
                    List View
                </button>
                <button type="button" class="view-button" [class.active]="viewMode === 'grouped'"
                    (click)="setViewMode('grouped')">
                    Group by Business
                </button>
            </div>
            <div class="search-container">
                <mat-icon class="search-icon">search</mat-icon>
                <input type="text" class="search-input" placeholder="Search screens, business, status..."
                    (keyup)="applyFilter($event)" />
            </div>
        </div>
    </div>

    <div class="stats-grid">
        @for (card of statCards; track card.label) {
        <div class="stat-card" [ngClass]="card.className">
            <span class="stat-label">{{ card.label }}</span>
            <span class="stat-value">{{ card.value }}</span>
        </div>
        }
    </div>

    <div class="card overflow-auto" appDynamicHeight [offset]="280" [minHeight]="300">
        @if (viewMode === 'list') {
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 screens-table">
            <ng-container matColumnDef="serial_no">
                <th mat-header-cell *matHeaderCellDef>#</th>
                <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
            </ng-container>

            <ng-container matColumnDef="screen_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Screen</th>
                <td mat-cell *matCellDef="let element">
                    <div class="fw-semibold">{{ element.screenName }}</div>
                    <div class="meta-line">ID: {{ element.screenId }}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="business_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Business</th>
                <td mat-cell *matCellDef="let element">
                    <div>{{ element.businessName }}</div>
                    <div class="meta-line">Business ID: {{ element.businessId ?? '-' }}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="operational_status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Screen Status</th>
                <td mat-cell *matCellDef="let element">
                    <span class="status-badge" [ngClass]="getStatusClass(element.operationalStatus)">
                        {{ element.operationalStatus }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="filler_ad">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Filler Ad</th>
                <td mat-cell *matCellDef="let element">
                    <span class="status-badge"
                        [ngClass]="element.fillerAdEnabled ? 'status-filler-enabled' : 'status-inactive'">
                        {{ element.fillerAdEnabled ? 'ENABLED' : 'DISABLED' }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="action_button">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <mat-icon class="cursor-pointer" (click)="openScreenDetail(element)">visibility</mat-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        }
        @else {
        <div class="grouped-wrapper">
            @for (group of groupedScreens; track group.businessName + '-' + group.businessId) {
            <div class="group-section">
                <button type="button" class="group-header" (click)="toggleGroup(group.businessId, group.businessName)"
                    [attr.aria-expanded]="isGroupExpanded(group.businessId, group.businessName)">
                    <div class="group-header-content">
                        <div class="group-title">{{ group.businessName }}</div>
                        <div class="group-subtitle">Business ID: {{ group.businessId ?? '-' }} | Screens: {{
                            group.screens.length }}</div>
                    </div>
                    <mat-icon class="group-toggle-icon">
                        {{ isGroupExpanded(group.businessId, group.businessName) ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                </button>

                @if (isGroupExpanded(group.businessId, group.businessName)) {
                <table mat-table [dataSource]="group.screens" class="mat-elevation-z8 grouped-table">
                    <ng-container matColumnDef="serial_no">
                        <th mat-header-cell *matHeaderCellDef>#</th>
                        <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
                    </ng-container>

                    <ng-container matColumnDef="screen_name">
                        <th mat-header-cell *matHeaderCellDef>Screen</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="fw-semibold">{{ element.screenName }}</div>
                            <div class="meta-line">ID: {{ element.screenId }}</div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="operational_status">
                        <th mat-header-cell *matHeaderCellDef>Screen Status</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="status-badge" [ngClass]="getStatusClass(element.operationalStatus)">
                                {{ element.operationalStatus }}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="filler_ad">
                        <th mat-header-cell *matHeaderCellDef>Filler Ad</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="status-badge"
                                [ngClass]="element.fillerAdEnabled ? 'status-filler-enabled' : 'status-inactive'">
                                {{ element.fillerAdEnabled ? 'ENABLED' : 'DISABLED' }}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action_button">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <mat-icon class="cursor-pointer" (click)="openScreenDetail(element)">visibility</mat-icon>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="groupedDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: groupedDisplayedColumns;"></tr>
                </table>
                }
            </div>
            }

            @if (groupedScreens.length === 0) {
            <div class="empty-grouped-state">No screens found for the current search.</div>
            }
        </div>
        }
    </div>
</div>
